// Anonymisierung der Antwort-Texte fuer die Karten-VORDERSEITE (und die
// Sprachausgabe). Regeln liegen in src/maskRules.json — geteilte Quelle mit
// tools/tts/generate_audio.py, damit Anzeige und Audio identisch anonym sind.
import rules from './maskRules.json';

export function anonymizeFrontText(text) {
  if (!text) return '';
  let out = text;
  for (const rule of rules) {
    if (rule.re) {
      out = out.replace(new RegExp(rule.p, 'g'), rule.r);
    } else {
      out = out.split(rule.f).join(rule.r);
    }
  }
  // Leerraum-Reste nach Streichungen bereinigen
  out = out.replace(/\s{2,}/g, ' ').replace(/\s+([,.;:!?])/g, '$1').trim();
  return out;
}
